import type { INotification } from '../../../Interfaces/INotification';

// PBT Notifications Action types
export const PBTNotificationsActionType = {
    REQUEST_NOTIFICATIONS: 'PBT/REQUEST_NOTIFICATIONS',
    RECEIVE_NOTIFICATIONS: 'PBT/RECEIVE_NOTIFICATIONS',
    ERROR_NOTIFICATIONS: 'PBT/ERROR_NOTIFICATIONS',
    MARK_READ_REQUEST: 'PBT/MARK_NOTIFICATION_READ_REQUEST',
    MARK_READ_SUCCESS: 'PBT/MARK_NOTIFICATION_READ_SUCCESS',
    MARK_ALL_READ_REQUEST: 'PBT/MARK_ALL_NOTIFICATIONS_READ_REQUEST',
    MARK_ALL_READ_SUCCESS: 'PBT/MARK_ALL_NOTIFICATIONS_READ_SUCCESS',
} as const;

export type PBTNotificationsAction =
    | IRequestNotificationsAction
    | IReceiveNotificationsAction
    | IErrorNotificationsAction
    | IMarkReadRequestAction
    | IMarkReadSuccessAction
    | IMarkAllReadRequestAction
    | IMarkAllReadSuccessAction;

export interface IRequestNotificationsAction {
    type: typeof PBTNotificationsActionType.REQUEST_NOTIFICATIONS;
}

export interface IReceiveNotificationsAction {
    type: typeof PBTNotificationsActionType.RECEIVE_NOTIFICATIONS;
    data: INotification[];
    unreadCount: number;
}

export interface IErrorNotificationsAction {
    type: typeof PBTNotificationsActionType.ERROR_NOTIFICATIONS;
    errorMessage?: string;
}

export interface IMarkReadRequestAction {
    type: typeof PBTNotificationsActionType.MARK_READ_REQUEST;
    notificationId: number;
}

export interface IMarkReadSuccessAction {
    type: typeof PBTNotificationsActionType.MARK_READ_SUCCESS;
    notificationId: number;
}

export interface IMarkAllReadRequestAction {
    type: typeof PBTNotificationsActionType.MARK_ALL_READ_REQUEST;
}

export interface IMarkAllReadSuccessAction {
    type: typeof PBTNotificationsActionType.MARK_ALL_READ_SUCCESS;
}
